module.exports = __webpack_public_path__ + "static/media/cfac06m.d9948c6d.png";